import { render, staticRenderFns } from "./LoadSpinner.vue?vue&type=template&id=852fcd02&scoped=true&"
import script from "./LoadSpinner.vue?vue&type=script&lang=ts&"
export * from "./LoadSpinner.vue?vue&type=script&lang=ts&"
import style0 from "./LoadSpinner.vue?vue&type=style&index=0&id=852fcd02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852fcd02",
  null
  
)

export default component.exports